import { create } from "zustand";

/** 'new-deck' = any NewDeckDropdown (Sidebar/HomeView). 'header-new-deck' = Header + dropdown. */
export type ActiveDropdownId = "new-deck" | "header-new-deck" | null;

interface DropdownStore {
  activeDropdownId: ActiveDropdownId;
  setActiveDropdownId: (id: ActiveDropdownId) => void;
}

export const useDropdownStore = create<DropdownStore>((set) => ({
  activeDropdownId: null,
  setActiveDropdownId: (id) => set({ activeDropdownId: id }),
}));
